module.exports = __webpack_public_path__ + "static/media/fireRate.5b06706b.png";